import "reflect-metadata"
import { jsonProperty, Serializable } from "ts-serializable"

export class BackendRequest extends Serializable {
  @jsonProperty(String)
  id?: string = undefined
}
